// import { Navbar } from "./Navbar";
import { TalentTourGuide } from './tours/TalentTourGuide';
import { SideBar } from "../sidebar/Sidebar";
import { useEffect, useRef } from 'react';
import { RecruiterTourGuide, RecTourHandle } from './tours/RecruiterTourGuide';
import { useGetUserInfo } from 'hooks/useGetUserInfo';
import { useTour } from './tours/TourGuideContext';
import { loadTour } from './tours/tourStorage';


export interface IProps {
  children: React.ReactNode;
  container?: boolean;
}

export const DashboardLayout: React.FC<IProps> = ({
  children,
  container = true,
}: IProps) => {
  const tourRef = useRef<any>(null);
  const recTourRef = useRef<any>(null);
  const { start } = useTour();
  const { userInfo } = useGetUserInfo();


  const handleStartTour = () => {
    // start();

    if (userInfo?.type === 'talent') {
      tourRef.current?.start('talent');
    } else {
      recTourRef.current?.start('recruiter');
    }
  };


  return (
    <div>
      <div className="flex w-full relative">
        <div className="w-64 fixed z-40 overflow-hidden lg:flex hidden">
          <TalentTourGuide ref={tourRef} />
          <RecruiterTourGuide ref={recTourRef} />
          <SideBar startTour={handleStartTour} />
        </div>
        <div className="w-full lg:ml-64 pb-10">
          {/* <Navbar /> */}
          <main className={container ? "Container" : ""}>{children}</main>
        </div>
      </div>
    </div>
  );
};
